import { getPuzzlePointsMilestone, PUZZLE_RANK_TIERS } from "./puzzleMedals";

export function getReachedPuzzleMilestone(previousPoints: number, points: number) {
  let target = getPuzzlePointsMilestone(previousPoints).target;
  let reached: number | null = null;
  while (Number.isFinite(points) && points >= target) {
    reached = target;
    target = getPuzzlePointsMilestone(target).target;
  }
  return reached;
}

const claimedInSession = new Set<string>();

// Persist acknowledgements so rating dips and page reloads don't replay rewards.
export function claimPuzzleAchievement(owner: string, achievement: string) {
  const key = `chesshotel:puzzle-achievement:v1:${owner}:${achievement}`;
  if (claimedInSession.has(key)) return false;
  try {
    if (localStorage.getItem(key)) return false;
    localStorage.setItem(key, "seen");
  } catch {
    // Still deduplicate for the current session when storage is unavailable.
  }
  claimedInSession.add(key);
  return true;
}

export function getReachedPuzzleMedal(previousRank: number | null | undefined, rank: number | null | undefined) {
  if (!previousRank || !rank || !Number.isFinite(previousRank) || !Number.isFinite(rank) || rank < 1) return null;
  return [...PUZZLE_RANK_TIERS].reverse().find((tier) => previousRank > tier && rank <= tier) ?? null;
}
